export enum RouteEnum {
  Home = 'Home',
  Settings = 'Settings',
  Article = 'Article',
  Page = 'Page',
}
